// extracted by mini-css-extract-plugin
module.exports = {"noop":"i18n_noop__3d893","ltr":"i18n_ltr__14sAh","rtl":"i18n_rtl__aoE90","editable":"i18n_editable__36JkK","invalidT":"i18n_invalidT__2H6U1","testId":"i18n_testId__2k4Et"};